import React from "react";
import {
  RootWrapper,
  ContentStack,
  StyledEmailIcon,
  StyledLinkIcon,
  StyledNorthEastIcon,
  ItemText,
} from "./LinkBox.styles";

const INVITE_LABEL = "Send invites to all users";

const LinkBox = ({ title, link, noMt, mb, onClick, invite = false }) => {
  const handleClick = () => {
    if (link) {
      window.open(link, "_blank");
    }
    if (onClick) {
      onClick();
    }
  };

  const displayTitle = invite ? INVITE_LABEL : title;

  return (
    <RootWrapper invite={invite} noMt={noMt} mb={mb} onClick={handleClick}>
      <ContentStack>
        {invite ? <StyledEmailIcon /> : <StyledLinkIcon />}
        <ItemText invite={invite}>{displayTitle}</ItemText>
      </ContentStack>
      <StyledNorthEastIcon />
    </RootWrapper>
  );
};

export default LinkBox;
